<template>
  <v-content id="content" app>
    <v-container class="fill-height fluid pa-0">
      <router-view></router-view>
    </v-container>
  </v-content>
</template>

<script>
export default {
  components: {},
};
</script>
""
<style>
#content {
  background-color: #fafafa;
  height: 100vh;
}
</style>